import '@/utils/initializeLocalStorage'
import _ from 'lodash'

const defaultUser = {
  email: localStorage.getItem('pn_user_email') || null,
  confirmed: localStorage.getItem('pn_user_confirmed') || null,
}

export default {
  namespaced: true,
  state: {
    ...defaultUser, // create new
  },
  mutations: {
    setUser(state, user) {
      state.email = user.email
      state.confirmed = user.confirmed
      localStorage.setItem('pn_user_email', user.email)
      localStorage.setItem('pn_user_confirmed', user.confirmed)
    },
  },
  actions: {
    logout({ commit }) {
      commit('request/authorized/setToken', null, { root: true })
      commit('setUser', {
        email: null,
        confirmed: null,
      })
    },
  },
  getters: {
    isLoggedIn: (__, ___, rootState) => {
      return _.isString(rootState.request.authorized.access)
    },
  },
}
